import "slick-carousel";

$(document).ready(function(){

    const prevBtn = '<div class="prev"><i class="icon-arrowback"></i></div>';
    const nextBtn = '<div class="next"><i class="icon-arrowright"></i></div>';


    $('[js-lab-slider]').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        mobileFirst: true,
        nextArrow: nextBtn,
        prevArrow : prevBtn,
        speed : 700,
        adaptiveHeight: true,
        cssEase: 'cubic-bezier(0.02, 0.31, 0.32, 0.99)',
        responsive: [{
            breakpoint: 960,
            settings: {
                autoplay: true,
                autoplaySpeed: 4000
            }
        }]
    });

});